import supabase from "../../supabaseClient/supabaseClient";

export const deductCredits = async (
  userId,
  amount = 1,
  setWorksheetsCount
) => {
  if (!userId) return false;

  const { data, error } = await supabase.rpc("deduct_credits", {
    user_id: userId,
    amount
  });

  if (error) {
    console.error("Error deducting credits:", error);
    return false;
  }

  // If null → user had no credits
  if (data === null) {
    console.warn("Not enough credits");
    return false;
  }

  // Update UI with new credit count
  setWorksheetsCount(data);

  return true;
};
